import type { GroupBookingData } from '@/scopes/account/group-responsible/domain/types'
import type { GroupBookingAPIResponse } from '@/scopes/account/group-responsible/infrastructure/types'

const validDirections = new Set(['Inbound', 'Outbound'] as const)

export function mapBuses(childBookings: GroupBookingAPIResponse['data']['childBookings']): GroupBookingData['buses'] {
  return childBookings
    .flatMap(item =>
      item.services
        .filter(service => service.typeOfService === 'Bus')
        .map((service) => {
          const direction = validDirections.has(service.direction as any)
            ? service.direction
            : undefined

          return {
            id: service.id.toString(),
            arrivalLocation: service.arrivalLocation || '',
            departureLocation: service.departureLocation || '',
            direction,
            busNumber: service.busNumber || '',
            participantsId: service.participantIds,
          }
        }),
    )
    .reduce((acc: Record<string, GroupBookingData['buses'][string]>, bus) => {
      acc[bus.id] = bus
      return acc
    }, {})
}
